import { render, staticRenderFns } from "./PurchasingListModal.vue?vue&type=template&id=516284f3&"
import script from "./PurchasingListModal.vue?vue&type=script&lang=js&"
export * from "./PurchasingListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports